import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'

// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import * as firebase from "firebase/app";
//import VueGtm from 'vue-gtm';

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/firestore";

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASEURL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MSESSAGINGSENDERID,
  appId: process.env.VUE_APP_FIREBASE_APPID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENTID
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
//firebase.analytics();

/* const $ = require('jquery')
window.$ = $ */


Vue.config.productionTip = false

/*if(process.env.VUE_APP_USE_GTM === 'true'){
  Vue.use(VueGtm, {
    id: process.env.VUE_APP_GTM_ID
  });
}*/

new Vue({
  render: h => h(App),
}).$mount('#app')
